// 快捷设置的菜单id
export const SHORT_CUT_MENU_ID = "kuaijieshezhi";

// 检测数据项目是否在IOS移动端下
export const isIosMobileAndData = (url) => {
  const ua = window.navigator.userAgent;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  const isTablet =
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua));
  return isTablet && url.indexOf("/data/new") > -1;
};

// 解析二级菜单URL
export const parseSecondMenuUrl = (menuUrl) => {
  try {
    const [match, category, url] =
      /^[\w]+:\/\/(?:([\w]+)\/?)?(|.*)$/.exec(menuUrl) || [];
    return { match, category, url };
  } catch (error) {
    console.error(menuUrl, error);
    return { match: "", category: "", url: "" };
  }
};

// 解析一级菜单URL
export const parseFirstMenuUrl = (menuUrl) => {
  try {
    const [match, category, position, url] =
      /(?:topmenu:\/\/)(\w+)(?:\|([^|.]+))?(?:\|(.+))?/gi.exec(menuUrl);
    return {
      match,
      category,
      position,
      url,
    };
  } catch (error) {
    console.error(menuUrl, error);
    return { match: "", category: "", url: "" };
  }
};

// 获取有效地址
const effectiveUrl = (url = "") => url.split(".html")[0];

// 计算URL和当前URL的权重
export const getWeight = (url, activeUrl) => {
  // FIXME: /tms/vehicle.html 与 /tms/vehicle.html?id=111 结果差异巨大
  url = effectiveUrl(url);
  activeUrl = effectiveUrl(activeUrl);

  if (url === activeUrl) {
    return 10000;
  }
  const urls = url.replace(".html", "").split("/");
  // 去掉jimupage对url的影响
  const activeUrls = activeUrl
    .replace("/jimupage", "")
    .replace(".html", "")
    .split("/");
  let weight = 0;
  activeUrls.some((k, index) => {
    if (k === urls[index]) {
      weight += index * 10 + 1;
    } else {
      return true;
    }
    return false;
  });
  return weight + 8 - urls.length; // 层级越短，权重越大
};
